export const intersect = (a: any[], b: any[]): boolean => {
  const setB = new Set(b);
  return [...new Set(a)].filter(x => setB.has(x)).length > 0;
};
